import { ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { projects } from "../data/content";
import type { MediaAsset } from "../types/content";
import { ResponsiveImage } from "./ResponsiveImage";

type AreaKey = "saude" | "infraestrutura" | "grandes-obras" | "investimentos";

interface AreaLink {
  key: AreaKey;
  label: string;
  title: string;
  href: string;
  media: MediaAsset;
}

const areaLinks: AreaLink[] = [
  { key: "saude", label: "Saúde", title: "Estrutura para cuidar das pessoas", href: "/saude", media: projects.find((item) => item.slug === "ubs")!.media[0] },
  { key: "infraestrutura", label: "Infraestrutura", title: "Mobilidade para cidade e interior", href: "/infraestrutura", media: projects.find((item) => item.slug === "asfalto-pedras")!.media[0] },
  { key: "grandes-obras", label: "Grandes obras", title: "Espaços para novos caminhos", href: "/grandes-obras", media: projects.find((item) => item.slug === "centro-eventos")!.media[0] },
  { key: "investimentos", label: "Investimento privado", title: "Energia, empregos e desenvolvimento", href: "/investimentos#eolico", media: projects.find((item) => item.slug === "eolico")!.media[0] },
];

export function AreaNavigator({ area }: { area: AreaKey }) {
  const current = areaLinks.findIndex((item) => item.key === area);
  const previous = areaLinks[(current - 1 + areaLinks.length) % areaLinks.length];
  const next = areaLinks[(current + 1) % areaLinks.length];

  return (
    <nav className="area-navigator" aria-label="Navegar entre as frentes">
      <div className="shell area-navigator__heading">
        <h2>Continue conhecendo as frentes.</h2>
        <p>Quatro áreas, cada uma com projetos, valores e registros próprios.</p>
      </div>
      <div className="area-navigator__grid">
        <AreaDirection item={previous} direction="previous" />
        <AreaDirection item={next} direction="next" />
      </div>
    </nav>
  );
}

function AreaDirection({ item, direction }: { item: AreaLink; direction: "previous" | "next" }) {
  const Icon = direction === "previous" ? ArrowLeft : ArrowRight;
  return (
    <Link className={`area-navigator__card area-navigator__card--${direction}`} to={item.href}>
      <ResponsiveImage media={item.media} alt="" sizes="(max-width: 700px) 100vw, 50vw" />
      <span className="area-navigator__shade" aria-hidden="true" />
      <span className="area-navigator__copy">
        <small>{direction === "previous" ? "Frente anterior" : "Próxima frente"}</small>
        <strong>{item.label}</strong>
        <span>{item.title}</span>
      </span>
      <span className="area-navigator__arrow"><Icon aria-hidden="true" /></span>
    </Link>
  );
}
